export default __webpack_public_path__ + "static/media/transaction-image.dfb5238b.png";